export default __webpack_public_path__ + "static/media/nav-icons.bc04e5ae.svg";